export interface WatchlistUiState {
    userId: string;
}

export const INITIAL_WATCHLIST_UI_STATE: WatchlistUiState = {
    userId: 'guest'
};



// WEBPACK FOOTER //
// ./node_modules/@nw/ui-watchlist/store/watchlist-ui-state.ts